module.exports = __webpack_public_path__ + "img/icon_map_51_off_100.4ed71169.png";